var agreementsModal = new tingle.modal({
  closeMethods: ['overlay', 'button', 'escape'],
  closeLabel: "Close",
  footer: true,
  stickyFooter: true,
});

agreementsModal.addFooterBtn('Close', 'btn', function() {
  // here goes some logic
  agreementsModal.close();
});

$(document).on("click", ".modal-open", function(e){
  var current = $(e.currentTarget);
  e.preventDefault();
  agreementsModal.setContent( $("[data-modal=" + current.data('modal-content') + "]" ).html() );
  agreementsModal.open();
})

var usStates = [
  {
    "name": "Alabama",
    "abbreviation": "AL"
  },
  {
    "name": "Alaska",
    "abbreviation": "AK"
  },
  {
    "name": "American Samoa",
    "abbreviation": "AS"
  },
  {
    "name": "Arizona",
    "abbreviation": "AZ"
  },
  {
    "name": "Arkansas",
    "abbreviation": "AR"
  },
  {
    "name": "California",
    "abbreviation": "CA"
  },
  {
    "name": "Colorado",
    "abbreviation": "CO"
  },
  {
    "name": "Connecticut",
    "abbreviation": "CT"
  },
  {
    "name": "Delaware",
    "abbreviation": "DE"
  },
  {
    "name": "District Of Columbia",
    "abbreviation": "DC"
  },
  {
    "name": "Federated States Of Micronesia",
    "abbreviation": "FM"
  },
  {
    "name": "Florida",
    "abbreviation": "FL"
  },
  {
    "name": "Georgia",
    "abbreviation": "GA"
  },
  {
    "name": "Guam",
    "abbreviation": "GU"
  },
  {
    "name": "Hawaii",
    "abbreviation": "HI"
  },
  {
    "name": "Idaho",
    "abbreviation": "ID"
  },
  {
    "name": "Illinois",
    "abbreviation": "IL"
  },
  {
    "name": "Indiana",
    "abbreviation": "IN"
  },
  {
    "name": "Iowa",
    "abbreviation": "IA"
  },
  {
    "name": "Kansas",
    "abbreviation": "KS"
  },
  {
    "name": "Kentucky",
    "abbreviation": "KY"
  },
  {
    "name": "Louisiana",
    "abbreviation": "LA"
  },
  {
    "name": "Maine",
    "abbreviation": "ME"
  },
  {
    "name": "Marshall Islands",
    "abbreviation": "MH"
  },
  {
    "name": "Maryland",
    "abbreviation": "MD"
  },
  {
    "name": "Massachusetts",
    "abbreviation": "MA"
  },
  {
    "name": "Michigan",
    "abbreviation": "MI"
  },
  {
    "name": "Minnesota",
    "abbreviation": "MN"
  },
  {
    "name": "Mississippi",
    "abbreviation": "MS"
  },
  {
    "name": "Missouri",
    "abbreviation": "MO"
  },
  {
    "name": "Montana",
    "abbreviation": "MT"
  },
  {
    "name": "Nebraska",
    "abbreviation": "NE"
  },
  {
    "name": "Nevada",
    "abbreviation": "NV"
  },
  {
    "name": "New Hampshire",
    "abbreviation": "NH"
  },
  {
    "name": "New Jersey",
    "abbreviation": "NJ"
  },
  {
    "name": "New Mexico",
    "abbreviation": "NM"
  },
  {
    "name": "New York",
    "abbreviation": "NY"
  },
  {
    "name": "North Carolina",
    "abbreviation": "NC"
  },
  {
    "name": "North Dakota",
    "abbreviation": "ND"
  },
  {
    "name": "Northern Mariana Islands",
    "abbreviation": "MP"
  },
  {
    "name": "Ohio",
    "abbreviation": "OH"
  },
  {
    "name": "Oklahoma",
    "abbreviation": "OK"
  },
  {
    "name": "Oregon",
    "abbreviation": "OR"
  },
  {
    "name": "Palau",
    "abbreviation": "PW"
  },
  {
    "name": "Pennsylvania",
    "abbreviation": "PA"
  },
  {
    "name": "Puerto Rico",
    "abbreviation": "PR"
  },
  {
    "name": "Rhode Island",
    "abbreviation": "RI"
  },
  {
    "name": "South Carolina",
    "abbreviation": "SC"
  },
  {
    "name": "South Dakota",
    "abbreviation": "SD"
  },
  {
    "name": "Tennessee",
    "abbreviation": "TN"
  },
  {
    "name": "Texas",
    "abbreviation": "TX"
  },
  {
    "name": "Utah",
    "abbreviation": "UT"
  },
  {
    "name": "Vermont",
    "abbreviation": "VT"
  },
  {
    "name": "Virgin Islands",
    "abbreviation": "VI"
  },
  {
    "name": "Virginia",
    "abbreviation": "VA"
  },
  {
    "name": "Washington",
    "abbreviation": "WA"
  },
  {
    "name": "West Virginia",
    "abbreviation": "WV"
  },
  {
    "name": "Wisconsin",
    "abbreviation": "WI"
  },
  {
    "name": "Wyoming",
    "abbreviation": "WY"
  }
]

$('[name=checkout]').click(function(e){
  if(firebase.auth().currentUser.uid !== undefined){
    firebase.auth().signOut();
  }
});


Vue.config.devtools = true;

var QuestionnaireConfig = {
  id: "KyJzNaX67qSoyuVwOLTq"
}

var db = firebase.firestore();

Vue.use(VueFormWizard);



Vue.component('formComponent', {
  template: `<vue-form-generator :model="model" tag="div" :schema="schema" :options="options"></vue-form-generator>`,
  props: ['schema', 'model', 'options'],
  components: {
    "vue-form-generator": VueFormGenerator.component
  }
});


var FieldMarkup = Vue.extend({
  mixins: [VueFormGenerator.abstractField],
  template: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras vestibulum ante lorem, auctor rutrum nisi dapibus in. Etiam bibendum, ipsum non lobortis fermentum, neque magna dignissim sapien, eget dignissim tellus lorem et tellus. In vitae odio lacinia, finibus quam sit amet, fermentum eros. Nunc condimentum, purus ac sollicitudin faucibus, diam mi vestibulum justo, vel imperdiet tellus urna at erat. In eu odio at elit scelerisque rutrum.</p>"
});

Vue.component("fieldMarkup", FieldMarkup);

var customCheckboxTemplate = '<div class="field-wrapper"><input :id="getFieldID(schema)" class="" type="checkbox" v-model="value" :disabled="disabled" :name="schema.inputName" :required="schema.required" :readonly="schema.readonly"><label :for="getFieldID(schema)" v-if="schema.inputLabel" v-html="schema.inputLabel" class="input-label"> </label> </div>';

var customCheckbox = Vue.extend({
  mixins: [VueFormGenerator.abstractField],
    template: customCheckboxTemplate
});

Vue.component("fieldCustomCheckbox", customCheckbox);

var signatureTemplate = '<div class="field-wrapper">'+
                          '<canvas @mouseup="handleMouseUp" ref="canvas"  :id="getFieldID(schema)"></canvas>'+
                          '<input class="" type="hidden" v-model="value" :required="schema.required" :readonly="schema.readonly">'+
                        '</div>'

var signatureField = Vue.extend({
  mixins: [VueFormGenerator.abstractField],
  template: signatureTemplate,
  created: function(){
    
  },
  watch: {
    value: function(val){
      if(this.signaturePad !== undefined){
        this.signaturePad.fromData(JSON.parse(this.value));
      }
    }
  },
  mounted: function(){
    console.log();
   
    var canvas = this.$refs.canvas;
    this.signaturePad = new SignaturePad(canvas, {
      backgroundColor: 'rgb(255, 255, 255)' // necessary for saving image as JPEG; can be removed is only saving as PNG or SVG
    });
 
  },
  methods: {
    handleMouseUp: function(){
      this.value = JSON.stringify(this.signaturePad.toData());
    }
  },
  data: function(){
    return {
      canvas: null,
      signaturePad: null
    }
  }
})

Vue.component("fieldSignature", signatureField);


var questionnaire = {
  delimiters: ['${', '}'],
  template: "#questionnaire-template",
  el: "#questionnaire",
  components: {
    "vue-form-generator": VueFormGenerator.component,
    "vue-form-wizard": VueFormWizard.component
  },

  created: function () {
    firebase.auth().onAuthStateChanged(this.authStateChanged);
  },
  methods: {

    validateTab: function (e, i) {
      var active = this.$refs.wizard.activeTabIndex;
      /* console.log("tab to validate", active);
      console.log(this.$refs);  */

      var refKey = "tab" + String(active);
      var tab = this.$refs[refKey];

      //console.log(tab); 

      if (tab !== undefined) {
        //console.log(tab[0].validate());
        return tab[0].validate();
      }
    },

    onComplete: function () {
      /* console.log('completed...'); */
      this.submitData();

      this.saved = false;
      var self = this;
      /* console.log(docRef); */
      this.savingData = true;

      var toSave = {};
      toSave.data = this.model;
      toSave.user = this.currentUser.uid
      toSave.questionnaireId = this.questionnaireId;

      if (this.loadedSubmission) {
        db.collection('submissions')
          .doc(this.loadedSubmission)
          .set(toSave).then(function (docRef) {
            /* console.log('saved data...', docRef); */
            $('#qid').val(self.loadedSubmission);
            self.saved = true;
            self.savingData = false;
            this.enableCheckout();

          }).catch(function (e) {
            /* console.log(e); */
            this.errorMsg = e.message;
          });
      } else {
        db.collection('submissions').add(toSave).then(function (docRef) {
          /* console.log('saved data...', docRef); */
          $('#qid').val(self.loadedSubmission);
          self.loadedSubmission = docRef.id;
          self.saved = true;
          self.savingData = false;

        }).catch(function (e) {
          /* console.log(e); */
          this.errorMsg = e.message;
        });
      }



    },
    onValidate: function(result, tab){
      var tabsCount = this.tabs.length;
      /* console.log("ON VALIDATE", result, tab); */
      
      if(tab == tabsCount - 1 && result == true){
        this.enableCheckout();
      }else{
        this.disableCheckout();
      }
      
      if(tab != tabsCount - 1 && result == true){
        $("body, html").animate({
          scrollTop: $('.wizard-nav').offset().top
        })
      }

      

    },
    prev: function () {
      if (this.step - 1 < 1) {
        return;
      } else {
        this.step = this.step - 1;
      }

    },
    next: function () {
      if (this.step + 1 > this.schema.fields.length) {
        return;
      } else {
        this.step = this.step + 1;
      }
    },

    disableCheckout: function () {
      document.querySelector('[name=checkout]').setAttribute('disabled', true);
    },
    enableCheckout: function () {
      //console.log("enabling checkout");
      document.querySelector('[name=checkout]').removeAttribute('disabled');
    },

    loginAnonymously: function () {
      var self = this;
      self.loggingIn = true;
      firebase.auth().signInAnonymously().catch(function (error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;

        self.error = error.message;

        // ...
      });

    },

    authStateChanged: function (user) {
      var self = this;
      if (user) {
        this.currentUser = user;
        this.started = true;
        //.log(user);
        document.getElementById('qid').value = user.uid;
        db.collection('questionnaires').doc(this.questionnaireId).get().then(function (doc) {
          var data = doc.data();
          if (data !== undefined) {
            self.init =  true;
            self.tabsTitle = data.title;
            self.tabsSubtitle = data.subtitle;
            
            data.tabs.forEach(function (tab, i) {
              //console.log(tab);
              if (tab.schema.groups !== undefined) {

                tab.schema.groups.forEach(function (group, j) {
                  group.fields.forEach(function (field, k) {
                    if (field.type == "input"
                      || field.type == "textArea"
                      || field.type == "radios") {
                      data.tabs[i].schema.groups[j].fields[k].validator = VueFormGenerator.validators.string;
                    }
                    if (field.type == "dateTimePicker") {
                      data.tabs[i].schema.groups[j].fields[k].validator = VueFormGenerator.validators.date;
                    }

                    if (field.model == "state") {
                      //console.log(usStates);
                      var states = usStates.map(function (item, index) {
                        return item.name;
                      });
                      //console.log(states);
                      field.values = states;
                    }

                    if(field.type == "checkbox"){
                      field.validator = function(value){
                        console.log('validate checkbox', value);

                        if(value === true){
                          return ['Mandatory field'];
                        } else{
                          return [];
                        }
                      }
                    }

                  });
                });
              } else if (tab.schema.fields !== undefined) {
                tab.schema.fields.forEach(function (field, j) {
                  /* fields.forEach(function (field, k) { */
                    if (field.type == "input"
                      || field.type == "textArea"
                      || field.type == "radios") {
                      data.tabs[i].schema.fields[j].validator = VueFormGenerator.validators.string;
                    }
                    if (field.type == "dateTimePicker") {
                      data.tabs[i].schema.fields[j].validator = VueFormGenerator.validators.date;
                    }

                    if (field.model == "state") {
                      var states = usStates.filter(function (index, item) {
                        return item.name;
                      });
                      //console.log(states);
                      field.values = states;
                    }

                    if(field.type == "checkbox" || field.type == "customCheckbox"){
                      field.validator = "required";
                      field.validator = function(value){
                        if(value == false){
                          return ['This value must be checked'];
                        } else{
                          return [];
                        }
                      }
                      if(field.model == "pathientAuthorizationConsent"){
                        field.hint = $(".patient-authorization-consent").html();
                      }
                      if(field.model == "privacyPolicyConsent"){
                        field.hint = $(".privacy-policy-content").html();
                      }
                      if(field.model == "telehealthConsent"){
                        field.hint = $(".telehealth-consent-content").html();
                      }
                      if(field.model == "telehealthConsent"){
                        field.hint = $(".therapy-management-consent ").html();
                      }
                    } 
                 /*  }); */
                });
              }

            });
            //console.log(data.tabs);
            self.tabs = data.tabs;
          }
        });

        db.collection('submissions')
          .where("user", "==", user.uid)
          .get()
          .then(function (querySnapshot) {
            //console.log(querySnapshot);
            var docRef = querySnapshot.docs[querySnapshot.docs.length - 1];

            var data = docRef.data();
            /* console.log("docRef", docRef);
            console.log("got data", data); */
            if (data !== undefined) {
              self.loadedSubmission = docRef.id
              self.model = data.data;

              $('#qid').val(self.loadedSubmission);

              /* self.total = self.getModelLength();
              var newPos = self.getFurthestStep();
              self.step = newPos;
              if(self.total == self.getModelLength() && self.isComplete()){
                self.saved = true;
              } */
            }
          }).catch(function (e) {
            //console.log(e);
          })
      } else {
        this.init = true;
        this.started = false;
      }
    },

    getFurthestStep: function () {
      var index = 0;
      var self = this;
      var modelLength = this.getModelLength();
      if (modelLength == 0) {
        return 1;
      } else if (modelLength == self.schema.fields.length) {
        return modelLength;
      } else {
        if (!this.schema.fields.length) return 1;
        for ($i = 0; $i <= this.schema.fields.length; $i++) {
          var key = this.schema.fields[$i];
          var field = self.model[key.model];
          if (field == undefined) {
            //console.log("Unanswered: ",$i, key.model);
            return $i + 1;
          }
        };
      }

    },

    modelUpdated: function (newVal, schema) {
      /* console.log(newVal, schema); */
      this.saved = false;
      //console.log("Saved:", this.saved);
      this.total = Object.keys(this.model).length;
      /* this.index = this.total; */
      var nextPos = this.getPositionInSchema(schema) + 1;
      if (nextPos > this.schema.fields.length) {
        nextPos = this.schema.fields.length
      }
      /*  console.log("Pos:", nextPos); */
      this.step = nextPos;

    },

    getPositionInSchema: function (schema) {
      var i = 0;
      for (i; i < this.schema.fields.length; i++) {
        var field = this.schema.fields[i];
        if (field.model == schema) {
          //console.log("Index in schea: ",field.model, schema); 
          return i + 1;
        }
      }
    },
    getModelLength: function () {
      return Object.keys(this.model).length;
    },
    checkout: function () {
      firebase.auth().signOut();
      document.querySelector('[name=checkout]').click();
    },
    isComplete: function () {
      if (this.getModelLength() == this.schema.fields.length) {
        return true;
      }
    },
    submitData: function () {

    }
  },
  watch: {
    /* total: function () {
       console.log('total watch:', this.getModelLength(), this.schema.fields.length); 
      if (this.getModelLength() == this.schema.fields.length) {
        this.complete = true;
      }
    }, */

    step: function (newVal, oldVal) {
      //console.log("new offset: ", newVal);

    },
    current: function () {
      this.scrollQuestions();
    },

    /* model: function(){
      this.total = this.schema.fields.length - (this.getModelLength() == 0 ? 0 : this.getModelLength());
    }, */

    /* schema: function(newVal){
      console.log(newVal, this.model);
      this.total = newVal.fields.length - (this.getModelLength() == 0 ? 0 : this.getModelLength());
    }, */

    /* complete: function () {
      if (this.schema.fields.length == this.getModelLength()
        && !this.savingData) {
        console.log('enable checkout');
        this.enableCheckout();
        return true
      } else {
        this.disableCheckout();
        return false;
      }
    }, */

  },

  computed: {
    /* progress: function () {
      console.log('compute progress...');
      var resultP = (100 / this.schema.fields.length) * this.total;
      console.log(this.schema.fields.length, this.total, resultP);
      return resultP;
    },

    offset: function () {
      if (this.step == 1) {
         console.log('step is 1'); 
        return 0;
      } else {
        return (this.step - 1) * -250;
      }
    } */

  },
  data: {
    init:false,
    savingData: false,
    index: 0,
    questionnaireId: QuestionnaireConfig.id,
    msg: "Some msd",
    errorMsg: "",
    complete: false,
    total: 0,
    started: false,
    loggingIn: false,
    step: 1,
    saved: false,
    tabsTitle: "",
		tabsSubtitle: "",
    loadedSubmission: null,
    schema: {
      fields: [

      ]
    },
    tabs: [],
    model: { firstName: "" },

    formOptions: {
      validationErrorClass: "has-error",
      validationSuccessClass: "has-success",
      validateAfterChanged: true
    },
    currentUser: null,
  }
}


if($('#questionnaire-template').length) {
  window.questionnaireApp = new Vue(questionnaire);
};

